import Link from 'next/link';
import Image from 'next/image';

export default function Nav() {
  return (
    <nav className="site-nav" style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      background: 'rgba(15, 29, 58, 0.92)',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid rgba(201, 164, 76, 0.2)',
      padding: '1rem 3rem',
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    }}>
      <div className="brand" style={{ display: 'flex', alignItems: 'center', gap: '0.9rem', color: 'var(--cream)' }}>
        <Image src="/logo.png" alt="Queen of Angels crest" width={42} height={42} priority style={{ height: 42, width: 'auto' }} />
        <div className="brand-text" style={{
          fontFamily: "'Fraunces', serif", fontWeight: 600,
          fontSize: '1.05rem', letterSpacing: '0.02em', lineHeight: 1.1,
        }}>
          Queen of Angels Primary School
          <small style={{
            display: 'block', fontFamily: "'Inter', sans-serif",
            fontWeight: 300, fontSize: '0.7rem', letterSpacing: '0.25em',
            color: 'var(--gold)', textTransform: 'uppercase', marginTop: '2px',
          }}>Est. 1976 · qoais50.ie</small>
        </div>
      </div>
      <ul className="nav-links" style={{
        listStyle: 'none', display: 'flex', gap: '2.5rem', alignItems: 'center',
      }}>
        <li className="nav-item"><Link href="#welcome" style={{
          color: 'var(--cream)', textDecoration: 'none', fontSize: '0.85rem',
          letterSpacing: '0.12em', textTransform: 'uppercase', fontWeight: 400,
          transition: 'color 0.3s',
        }} onMouseOver={e => (e.currentTarget.style.color = 'var(--gold)')}
           onMouseOut={e => (e.currentTarget.style.color = 'var(--cream)')}
        >Welcome</Link></li>
        <li className="nav-item"><Link href="#gallery" style={{
          color: 'var(--cream)', textDecoration: 'none', fontSize: '0.85rem',
          letterSpacing: '0.12em', textTransform: 'uppercase', fontWeight: 400,
          transition: 'color 0.3s',
        }} onMouseOver={e => (e.currentTarget.style.color = 'var(--gold)')}
           onMouseOut={e => (e.currentTarget.style.color = 'var(--cream)')}
        >Through the Years</Link></li>
        <li className="nav-item"><Link href="#events" style={{
          color: 'var(--cream)', textDecoration: 'none', fontSize: '0.85rem',
          letterSpacing: '0.12em', textTransform: 'uppercase', fontWeight: 400,
          transition: 'color 0.3s',
        }} onMouseOver={e => (e.currentTarget.style.color = 'var(--gold)')}
           onMouseOut={e => (e.currentTarget.style.color = 'var(--cream)')}
        >Events</Link></li>
        <li><Link href="#register" className="btn-login" style={{
          background: 'var(--gold)', color: 'var(--navy-deep)',
          padding: '0.6rem 1.4rem', borderRadius: '2px',
          fontWeight: 500, letterSpacing: '0.1em', textDecoration: 'none',
          fontSize: '0.85rem', textTransform: 'uppercase', border: 'none',
          cursor: 'pointer', transition: 'all 0.3s',
        }} onMouseOver={e => {
          e.currentTarget.style.background = 'var(--gold-light)';
        }} onMouseOut={e => {
          e.currentTarget.style.background = 'var(--gold)';
        }}>Register</Link></li>
      </ul>
    </nav>
  );
}
